import { desktopDownloadFor } from '../Home/desktopDownload'

export const INTELLIKEY_IOS_APP_STORE_URL =
  'https://apps.apple.com/us/app/intellikey/id1667188645'

export const isMobileBrowser = navigatorLike => {
  if (!navigatorLike) return false

  const userAgent = navigatorLike.userAgent || ''
  const platform = navigatorLike.platform || ''
  const clientPlatform = navigatorLike.userAgentData && navigatorLike.userAgentData.platform
  return /iPhone|iPad|iPod|Android|Mobile\//i.test(userAgent) ||
    /^(iPhone|iPad|iPod)$/i.test(platform) ||
    clientPlatform === 'iOS' ||
    clientPlatform === 'Android' ||
    (platform.startsWith('Mac') && Number(navigatorLike.maxTouchPoints || 0) > 1)
}

export const providerConnectionInstallPrompt = ({
  isNative,
  navigatorLike,
  desktopReleases
}) => {
  if (isNative) return null

  if (isMobileBrowser(navigatorLike)) {
    return {
      kind: 'ios',
      title: 'Connect providers in the IntelliKey iOS app',
      message: 'Install IntelliKey from the App Store to connect an AI provider.',
      actionLabel: 'INSTALL FROM APP STORE',
      providerActionLabel: 'Install IntelliKey to connect',
      url: INTELLIKEY_IOS_APP_STORE_URL
    }
  }

  const download = desktopDownloadFor({
    navigatorLike,
    isMacApp: false,
    isWindowsApp: false,
    desktopReleases
  })
  return {
    kind: 'desktop',
    title: 'Connect providers in IntelliKey Desktop',
    message: 'Download and open the native IntelliKey app to connect an AI provider.',
    actionLabel: 'DOWNLOAD INTELLIKEY',
    providerActionLabel: 'Download IntelliKey to connect',
    url: download && download.url
  }
}
